module.exports = __webpack_public_path__ + "img/Telediagnosebewertungen.d96e5c38.svg";